import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { Nullable } from '@ps/utils';
import {
  BillingRules,
  BuyerSettings,
  BuyerSettingsSave,
} from './buyer-state.model';

export const BuyerActions = createActionGroup({
  source: 'Buyer',
  events: {
    'Load Buyer Settings': props<{ buyerId: number }>(),
    'Load Buyer Settings Success': props<{ buyer: BuyerSettings }>(),
    'Load Buyer Settings Failure': props<{ error: string }>(),

    'Save Buyer Settings': props<{
      cmp: number;
      update: Partial<BuyerSettingsSave>;
    }>(),
    'Save Buyer Settings Success': emptyProps(),
    'Save Buyer Settings Failure': props<{ error: string }>(),

    'Load Decipher Hash Key Ids': emptyProps(),
    'Load Decipher Hash Key Ids Success': props<{ keyIds: number[] }>(),
    'Load Decipher Hash Key Ids Failure': props<{ error: string }>(),

    'Load Billing Rules': emptyProps(),
    'Load Billing Rules Success': props<{
      billingRules: Nullable<BillingRules>;
    }>(),
    'Load Billing Rules Failure': props<{ error: string }>(),

    'Create Billing Rules': props<{ billingRules: BillingRules }>(),
    'Create Billing Rules Success': props<{ billingRules: BillingRules }>(),
    'Create Billing Rules Failure': props<{ error: string }>(),

    'Update Billing Rules': props<{ billingRules: BillingRules }>(),
    'Update Billing Rules Success': props<{ billingRules: BillingRules }>(),
    'Update Billing Rules Failure': props<{ error: string }>(),
  },
});
